import { useEffect, useState } from "react";
import LayeredDashboardHeader from "../LayeredDashboardHeader";
import { useNavigate } from "react-router-dom";
import LayeredDashboardModal from "./Modals/LayeredDashboardModal";
import CreateAction from "../../components/operational/createAction";
import PrimaryButton from "../../components/ui/PrimaryButton";
import SmartBannerPhone from "../../components/ui/SmartBannerPhone";
import HexColor from "../ThemeScreen/DnDNew/components/DnDItems/DnDSidebarItems/Inputs/HexColor";
import SecondaryButton from "../../components/ui/SecondaryButton";
import { useSelector } from "react-redux";
import { InputTextarea } from "primereact/inputtextarea";
import useCustomNavigate from "../../components/operational/goBack";
import QRCode from "react-qr-code";


function copyScriptAsText(text) {
  // Get the text field
  // Select the text field

  // Copy the text inside the text field
  navigator.clipboard.writeText(text);

  alert("Kopyalandı!")


}

const DynamicQR = ({ tab }) => {

  const myAppsData = useSelector((state) => state.myAppsSlice.localReduxData)

  const app = myAppsData?.app

  const href = `https://mymobligo.com/${app?.mobligoSubdomain}`
  return (<>
    <LayeredDashboardHeader tab={tab}>

    </LayeredDashboardHeader>
    <div className='w-full h-[calc(100dvh-60px)] overflow-auto scrollbar-y-visible'>
      <div className="p-[20px] flex justify-center items-center">
        <div className="bg-white p-[20px] max-w-[1120px]  w-[100%] rounded-[10px]">
          <div className="flex flex-col w-full gap-[15px] px-[20px]">
            <div className="flex flex-col gap-[15px] items-center py-[32px] ">

              <div className="font-medium text-[24px]">
                Dinamik QR
              </div>
              <div className="font-semibold text-gray-500 text-[14px]">
                Link ve QR kodunuzu paylaşarak kullanıcılarınıza uygulamanızı indirtebilirsiniz.
              </div>

            </div>
            <div className="flex flex-row gap-[40px] justify-between items-center">
              <div className="flex flex-col w-full max-w-[700px] gap-[20px]">
                <div>

                  <label for="first_name" class="block mb-2 text-sm font-medium text-[14px] text-gray-900 dark:text-white">mobligo Dinamik Uygulama Linki</label>
                  <input disabled className="w-full border-2 p-3 rounded-[5px] bg-gray-200 text-gray-400 " value={href} type="text" />
                </div>
                <div>

                  <PrimaryButton
                    onClick={() => {
                      copyScriptAsText(href)
                    }}
                    value="Kopyala"
                    classes="!bg-[#F3F2FC] !text-[#7059ef] px-[20px] text-[14px] !border-[#7059ef] border-1 "
                  ></PrimaryButton>
                </div>
              </div>
              <div className="p-[10px] !bg-[#F3F2FC] !text-[#7059ef]  text-[14px] !border-[#7059ef] border-1 w-[200px] h-[200px] rounded-[8px]">

                <QRCode
                  size={256}
                  style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                  value={href}
                  className="shrink-0"
                  viewBox={`0 0 256 256`}

                >


                </QRCode>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >


  </>)
};

export default DynamicQR;
